import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LpiReportsTab } from './types';

interface LpiTabBarProps {
  activeTab: LpiReportsTab;
  onTabChange: (tab: LpiReportsTab) => void;
}

/**
 * Top-level tab bar for the LPI Reports page.
 *
 * Markup and class names mirror the CPI tab bar (CpiReports.tsx) so the two
 * report pages look and behave identically; only the block prefix differs.
 */
const LpiTabBar: FC<LpiTabBarProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="lpi-reports__tab-bar">
      <button
        type="button"
        className={`lpi-reports__tab ${
          activeTab === 'dashboard' ? 'lpi-reports__tab--active' : ''
        }`}
        onClick={() => onTabChange('dashboard')}
      >
        {t('lpi.tab.dashboard')}
      </button>
      <button
        type="button"
        className={`lpi-reports__tab ${
          activeTab === 'details' ? 'lpi-reports__tab--active' : ''
        }`}
        onClick={() => onTabChange('details')}
      >
        {t('lpi.tab.details')}
      </button>
    </div>
  );
};

export default LpiTabBar;
